'use strict';

//import { debug } from 'console';
//import { sign } from 'crypto';


//export const BaseURL = 'http://hass.digitaldiary.svn';

export const BaseURL = 'https://hass.digitaldiary.wms-it.net';

//export const BaseURL = 'https://earbuzz.hass.co.za';
